(() => {
  const contextElement = document.getElementById('KickisAnalyticsContext');
  if (!contextElement) return;

  let context = {};
  try {
    context = JSON.parse(contextElement.textContent || '{}');
  } catch (error) {
    console.warn('Kunde inte läsa analyskontext.', error);
    return;
  }
  if (!context.enabled || !context.endpoint) return;

  const visitorKey = 'kickis:analytics:visitor:v1';
  const sessionKey = 'kickis:analytics:session:v1';
  const cartKey = 'kickis:analytics:cart:v1';
  const feedbackKey = 'kickis:analytics:feedback:v1';
  const queue = [];
  let allowed = false;
  let consentRecorded = '';
  let pageTracked = false;
  let flushTimer = null;
  let patternId = new URLSearchParams(window.location.search).get('pattern');

  const uuid = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const device = () => window.matchMedia('(max-width: 749px)').matches ? 'mobile' : window.matchMedia('(max-width: 989px)').matches ? 'tablet' : 'desktop';
  const getStoredId = (storage, key) => {
    let value = storage.getItem(key);
    if (!value) { value = uuid(); storage.setItem(key, value); }
    return value;
  };
  const clearAnalyticsStorage = () => {
    try { localStorage.removeItem(visitorKey); } catch (_) { /* Storage can be unavailable. */ }
    try { sessionStorage.removeItem(sessionKey); sessionStorage.removeItem(cartKey); } catch (_) { /* Storage can be unavailable. */ }
    queue.length = 0;
  };
  const currentItem = () => ({
    itemType: patternId ? 'pattern' : context.itemType || null,
    itemKey: patternId ? `pattern:${patternId}` : context.itemKey || null,
    variantKey: context.variantKey ? String(context.variantKey) : null,
    itemTitle: context.itemTitle || null,
    itemUrl: context.itemUrl || window.location.pathname + window.location.search,
    imageUrl: context.imageUrl || null,
  });

  const event = (eventType, detail = {}) => {
    if (!allowed || context.isPreview) return;
    queue.push({
      eventId: uuid(), eventType, pageType: context.pageType || 'other', ...currentItem(),
      url: window.location.href, referrer: document.referrer, device: device(),
      source: 'storefront-theme-analytics', ...detail,
    });
    window.clearTimeout(flushTimer);
    flushTimer = window.setTimeout(flush, 200);
  };
  const flush = async () => {
    if (!allowed || !queue.length) return;
    const events = queue.splice(0, 20);
    try {
      const response = await fetch(context.endpoint, {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          visitorId: getStoredId(localStorage, visitorKey),
          sessionId: getStoredId(sessionStorage, sessionKey),
          consent: { analytics: true, recorded: consentRecorded === 'yes' ? 'yes' : 'allowed', source: 'shopify_customer_privacy' },
          events,
        }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
    } catch (error) {
      console.warn('Kunde inte skicka samtyckt analysdata.', error);
    }
  };

  const normaliseCartItems = (cart) => (cart?.items || []).slice(0, 50).map((line) => ({
    itemType: 'product', itemKey: `product:${line.product_id}`, variantKey: String(line.variant_id || line.id || ''),
    title: line.product_title || line.title || null, variantTitle: line.variant_title || null,
    quantity: Number(line.quantity || 1), unitValueMinor: Number(line.final_price ?? line.price ?? 0),
    valueMinor: Number(line.final_line_price ?? line.line_price ?? 0), source: 'shopify_cart',
  }));
  const readPreviousCart = () => {
    try { return JSON.parse(sessionStorage.getItem(cartKey) || '[]'); } catch (_) { return []; }
  };
  const snapshotCart = async (reason = 'page', emitDifferences = true) => {
    if (!allowed) return null;
    try {
      const response = await fetch(`${window.routes?.root || '/'}cart.js?_analytics=${Date.now()}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return null;
      const cart = await response.json();
      const items = normaliseCartItems(cart);
      const previous = readPreviousCart();
      const previousMap = new Map(previous.map((item) => [`${item.itemKey}:${item.variantKey}`, item]));
      const currentMap = new Map(items.map((item) => [`${item.itemKey}:${item.variantKey}`, item]));
      if (emitDifferences) {
        items.forEach((item) => {
          const oldQuantity = Number(previousMap.get(`${item.itemKey}:${item.variantKey}`)?.quantity || 0);
          if (item.quantity > oldQuantity) event('cart_added', { ...item, quantity: item.quantity - oldQuantity, valueMinor: item.unitValueMinor * (item.quantity - oldQuantity) });
        });
        previous.forEach((item) => {
          const newQuantity = Number(currentMap.get(`${item.itemKey}:${item.variantKey}`)?.quantity || 0);
          if (item.quantity > newQuantity) event('cart_removed', { ...item, quantity: item.quantity - newQuantity, valueMinor: item.unitValueMinor * (item.quantity - newQuantity) });
        });
      }
      sessionStorage.setItem(cartKey, JSON.stringify(items));
      event('cart_snapshot', { items, quantity: Number(cart.item_count || 0), valueMinor: Number(cart.total_price || 0), currency: context.currency || 'SEK', metadata: { reason } });
      return { cart, items };
    } catch (_) {
      return null;
    }
  };

  const trackPage = () => {
    if (pageTracked || !allowed) return;
    pageTracked = true;
    event(patternId ? 'pattern_viewed' : context.pageType === 'product' ? 'product_viewed' : 'page_viewed');
    if (context.pageType === 'cart') event('cart_viewed');
    trackSearch(window.KickisSearchMeasurement?.last);
    window.setTimeout(() => snapshotCart('page', false), 350);
  };
  const updateDebug = () => {
    const status = document.querySelector('[data-kickis-analytics-status]');
    if (status) status.textContent = allowed ? 'Statistik och analys är tillåten.' : 'Statistik och analys är inte tillåten.';
  };
  const applyConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    allowed = Boolean(privacy?.analyticsProcessingAllowed?.());
    consentRecorded = privacy?.currentVisitorConsent?.()?.analytics || '';
    if (!allowed) { clearAnalyticsStorage(); pageTracked = false; } else trackPage();
    updateDebug();
  };
  const trackedSearches=new Set();
  const trackSearch = (detail) => {
    if(!allowed || !detail || detail.measurementVersion!==2 || !Number.isInteger(detail.resultCount) || detail.resultCount<0 || trackedSearches.has(detail.searchId))return;
    trackedSearches.add(detail.searchId);
    if(detail.searchAction!=='search')return; // Pagination/filtering are not new search intents.
    // One canonical event. The dashboard derives no-results from its real total.
    event('search_performed',{eventId:'search:'+detail.searchId,metadata:detail});
  };
  document.addEventListener('kickis:search:completed',event=>trackSearch(event.detail));
  const loadPrivacy = () => {
    if (!window.Shopify?.loadFeatures) return updateDebug();
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) { console.warn('Kunde inte läsa cookie-samtycket.', error); return; }
      applyConsent();
    });
  };
  const addDebugPanel = () => {
    if (new URLSearchParams(window.location.search).get('kickis_analytics_debug') !== '1') return;
    const panel = document.createElement('aside');
    panel.className = 'kickis-analytics-debug';
    panel.innerHTML = '<strong>Analysprototyp</strong><span data-kickis-analytics-status>Kontrollerar cookie-val…</span><div><button type="button" data-analytics-consent="yes">Tillåt Statistik och analys</button><button type="button" data-analytics-consent="no">Avvisa</button></div><small>Valet sparas i butikens cookieinställningar. Favoriter fungerar oberoende av detta val.</small>';
    document.body.appendChild(panel);
    panel.addEventListener('click', (clickEvent) => {
      const button = clickEvent.target.closest('[data-analytics-consent]');
      if (!button || !window.Shopify?.customerPrivacy?.setTrackingConsent) return;
      window.Shopify.customerPrivacy.setTrackingConsent({ analytics: button.dataset.analyticsConsent === 'yes' }, applyConsent);
    });
  };

  const setupFeedback = () => {
    const progressKey = 'kickis:feedback:active-seconds:v2';
    const read = (key) => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
    const write = (key, value) => { try { sessionStorage.setItem(key, String(value)); } catch (_) { /* Optional session memory. */ } };
    let seconds = Math.min(45, Math.max(0, Number(read(progressKey)) || 0));
    let searching = ['search', 'collection', 'product'].includes(context.pageType) || /\/pages\/monster(?:\/|$)/.test(location.pathname);
    let lastActivity = Date.now();
    let lastTick = Date.now();
    let idleSeconds = 0;
    let offered = Boolean(read(feedbackKey));
    let prompt = null;
    let returnFocus = null;
    // Chromium can report a rectangle for content inside a closed <details>.
    const visible = (element) => Boolean(element && !element.closest('details:not([open]), [hidden], [aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const blocked = () => Boolean(document.querySelector('body.overflow-hidden, body.pre-checkout-upsell-open')) ||
      [...document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, details[open] > .search-modal, #shopify-pc__banner')].some(visible);
    const editing = () => Boolean(document.activeElement?.closest('input, textarea, select, [contenteditable="true"]'));
    const dismiss = () => {
      write(feedbackKey, 'dismissed');
      if (prompt?.contains(document.activeElement) && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      prompt?.remove(); prompt = null;
    };
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((name) => document.addEventListener(name, () => { lastActivity = Date.now(); }, { passive: true }));
    document.addEventListener('kickis:search:completed', () => { searching = true; lastActivity = Date.now(); });
    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed) { prompt?.remove(); prompt = null; seconds = 0; write(progressKey, 0); }
    });
    const addFeedbackPrompt = () => {
    const prompt = document.createElement('aside');
    prompt.className = 'kickis-feedback';
    prompt.setAttribute('aria-label', 'Dela din upplevelse');
    prompt.innerHTML = '<button class="kickis-feedback__teaser" type="button" aria-expanded="false" aria-controls="KickisFeedbackPanel"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-8 8H4l1-4a8 8 0 1 1 15-4Z"/><path d="M8 10h8M8 14h5"/></svg><span>Hittade du det du sökte?</span></button><button class="kickis-feedback__close" type="button" aria-label="Stäng frågan för detta besök">×</button><div id="KickisFeedbackPanel" hidden><p class="kickis-feedback__eyebrow">Vi lyssnar gärna</p><h2>Hittade du det du sökte?</h2><p class="kickis-feedback__intro">Dina tips hjälper oss att göra butiken bättre.</p><div class="kickis-feedback__choices"><button type="button" data-feedback-answer="Ja">Ja, tack!</button><button type="button" data-feedback-answer="Inte än">Inte än</button></div><form hidden><label for="KickisFeedbackComment">Vad letar du efter?</label><textarea id="KickisFeedbackComment" name="comment" maxlength="800" rows="3" aria-describedby="KickisFeedbackHint"></textarea><small id="KickisFeedbackHint">Valfritt. Skriv inte namn eller kontaktuppgifter.</small><button type="submit">Skicka feedback</button></form><p data-feedback-thanks role="status" hidden></p></div>';
    document.body.appendChild(prompt);
    const finish = (response, comment = '') => {
      if (!allowed) { dismiss(); return; }
      event('feedback_submitted', { metadata: { response, comment } });
      write(feedbackKey, '1');
      prompt.querySelector('.kickis-feedback__choices').hidden = true;
      prompt.querySelector('form').hidden = true;
      prompt.querySelector('[data-feedback-thanks]').hidden = false;
      prompt.querySelector('[data-feedback-thanks]').textContent = context.isPreview ? 'Tack! Detta är ett test i dev-temat. Inget svar skickas.' : 'Tack för att du hjälper oss att bli bättre!';
      prompt.querySelector('.kickis-feedback__close').focus({ preventScroll: true });
      window.setTimeout(dismiss, 5000);
    };
    prompt.addEventListener('click', (clickEvent) => {
      if (clickEvent.target.closest('.kickis-feedback__close')) { dismiss(); return; }
      if (clickEvent.target.closest('.kickis-feedback__teaser')) {
        const teaser = prompt.querySelector('.kickis-feedback__teaser');
        prompt.classList.add('is-expanded');
        teaser.hidden = true;
        teaser.setAttribute('aria-expanded', 'true');
        prompt.querySelector('#KickisFeedbackPanel').hidden = false;
        prompt.querySelector('[data-feedback-answer]').focus({ preventScroll: true });
      }
      const answer = clickEvent.target.closest('[data-feedback-answer]')?.dataset.feedbackAnswer;
      if (answer === 'Ja') finish(answer);
      if (answer === 'Inte än') { prompt.querySelector('.kickis-feedback__choices').hidden = true; prompt.querySelector('form').hidden = false; prompt.querySelector('textarea').focus(); }
    });
    prompt.querySelector('form').addEventListener('submit', (submitEvent) => {
      submitEvent.preventDefault();
      finish('Inte än', String(new FormData(submitEvent.currentTarget).get('comment') || '').trim());
    });
    prompt.addEventListener('keydown', (keyEvent) => {
      if (keyEvent.key === 'Escape') { keyEvent.stopPropagation(); dismiss(); }
    });
    return prompt;
    };
    // Count only visible, recently active browsing, across page visits in this tab.
    // No scroll work or network requests: one inexpensive check per second.
    window.setInterval(() => {
      const now = Date.now(), elapsed = Math.min(2, Math.max(0, (now - lastTick) / 1000));
      lastTick = now;
      if (!allowed || document.hidden) return;
      const interrupted = blocked() || (editing() && !prompt?.contains(document.activeElement));
      if (prompt) {
        prompt.hidden = interrupted;
        if (!interrupted && !prompt.classList.contains('is-expanded') && !prompt.matches(':hover') && !prompt.contains(document.activeElement)) idleSeconds += elapsed;
        if (idleSeconds >= 20) dismiss();
        return;
      }
      if (offered || !searching || interrupted || Date.now() - lastActivity > 30_000 || context.pageType === 'cart') return;
      seconds += elapsed;
      write(progressKey, Math.min(45, seconds));
      if (seconds >= 45) {
        offered = true; write(feedbackKey, 'offered');
        returnFocus = document.activeElement;
        prompt = addFeedbackPrompt();
      }
    }, 1000);
  };

  document.addEventListener('visitorConsentCollected', applyConsent);
  document.addEventListener('kickis:analytics:event', (customEvent) => {
    if (customEvent.detail?.eventType) event(customEvent.detail.eventType, customEvent.detail);
  });
  document.addEventListener('click', (clickEvent) => {
    const patternCard = clickEvent.target.closest('[data-pattern-card]');
    if (patternCard?.dataset.patternId) {
      patternId = patternCard.dataset.patternId;
      const container = patternCard.closest('.pattern-card') || patternCard.parentElement;
      const favoriteData = container?.querySelector('[data-favorite-toggle]');
      context.itemTitle = favoriteData?.dataset.favoriteTitle || patternId;
      const routeRoot = window.Shopify?.routes?.root || '/';
      context.itemUrl = favoriteData?.dataset.favoriteUrl || `${routeRoot}pages/monster/${encodeURIComponent(patternId)}`;
      context.imageUrl = favoriteData?.dataset.favoriteImage || container?.querySelector('img')?.src || null;
      event('pattern_viewed');
    }
    const favorite = clickEvent.target.closest('[data-favorite-toggle]');
    if (favorite) event(favorite.getAttribute('aria-pressed') === 'true' ? 'favorite_removed' : 'favorite_added', {
      itemType: favorite.dataset.favoriteType || currentItem().itemType,
      itemKey: favorite.dataset.favoriteId ? `${favorite.dataset.favoriteType || 'product'}:${favorite.dataset.favoriteId}` : currentItem().itemKey,
      itemTitle: favorite.dataset.favoriteTitle, itemUrl: favorite.dataset.favoriteUrl, imageUrl: favorite.dataset.favoriteImage,
    });
    if (clickEvent.target.closest('button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, [data-upsell-continue]')) {
      const items = readPreviousCart();
      event('checkout_clicked', { items, quantity: items.reduce((sum, item) => sum + Number(item.quantity || 0), 0), valueMinor: items.reduce((sum, item) => sum + Number(item.valueMinor || 0), 0), currency: context.currency || 'SEK' });
      flush();
    }
  }, true);
  document.addEventListener('change', (changeEvent) => {
    const control = changeEvent.target.closest('select[name^="filter."], input[name^="filter."], [data-facet-filter]');
    if (control) event('filter_used', { metadata: { filter: control.name || control.dataset.facetFilter || 'filter', filterValue: control.value || control.dataset.value || 'valt' } });
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    addDebugPanel(); loadPrivacy();
    let lastActivity = Date.now();
    let deepScrollTracked = false;
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((name) => document.addEventListener(name, () => { lastActivity = Date.now(); }, { passive: true }));
    window.setInterval(() => {
      if (!allowed || document.hidden || Date.now() - lastActivity > 30_000) return;
      event('engagement_ping', { quantity: 15 });
    }, 15_000);
    document.addEventListener('scroll', () => {
      if (deepScrollTracked || !allowed) return;
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / scrollable >= 0.75) { deepScrollTracked = true; event('scroll_depth', { quantity: 75 }); }
    }, { passive: true });
    setupFeedback();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const variant = payload?.data?.variant || payload?.variant;
        if (!variant?.id) return;
        context.variantKey = String(variant.id);
        event('variant_selected', { variantKey: String(variant.id), metadata: { variantTitle: variant.title || '' } });
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(() => snapshotCart('cart_update', true), 200));
    }
  });
  window.addEventListener('pagehide', flush);
})();
